<i class="fad" [class.fa-sort]="!isAsc && !isDesc" [class.fa-sort-up]="isAsc" [class.fa-sort-down]="isDesc"></i>

